import React from 'react'
import './welcome-section.scss'

const WelcomeSection = () => {
    return (
        <div className="welcome-section">
            <div className="row align-items-center">
                <div className="col-lg-5">
                    <div className="welcome-heading">
                        <span>Welcome,</span>
                        <h2>Jason Wong</h2>
                    </div>
                </div>
                <div className="col-lg-7">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="welcome-card">
                                <p>
                                    <img src="/images/icons/flights.svg" alt="icon" />
                                    <span>Upcoming Flights</span>
                                </p>
                                <h2>02</h2>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="welcome-card">
                                <p>
                                    <img src="/images/icons/hotels.svg" alt="icon" />
                                    <span>Hotel Booking</span>
                                </p>
                                <h2>02</h2>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="welcome-card">
                                <p>
                                    <img src="/images/icons/simcard.svg" alt="icon" />
                                    <span>eSim Registered</span>
                                </p>
                                <h2>02</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WelcomeSection